module.exports = __webpack_public_path__ + "static/img/bg-es.cac1829b.webp";